module.exports = __webpack_public_path__ + "img/icon_hfgm.bccc4fed.png";